import React, { useEffect, useState, useRef } from "react";
import ContextMenu from "../ContextMenu/ContextMenu";
import dotsIcon from "../../assets/dots.svg";
import commentsIcon from "../../assets/comments.svg";
import eyeIcon from "../../assets/eye.svg";
import { useMenu } from "../../context/MenuContext";
import { useTranslation } from "react-i18next";
import momentTz from "moment-timezone";
import moment from "moment";
import momentWithLocales from "moment/min/moment-with-locales";
import DummyPoster1 from "../../assets/backgrounds/background_1.svg";
import DummyPoster2 from "../../assets/backgrounds/background_2.svg";
import DummyPoster3 from "../../assets/backgrounds/background_3.svg";
import DummyPoster4 from "../../assets/backgrounds/background_4.svg";
import DummyPoster5 from "../../assets/backgrounds/background_5.svg";
import DummyPoster6 from "../../assets/backgrounds/background_6.svg";
import { useDispatch, useSelector } from "react-redux";
import VersionContextMenu from "../VersionContextMenu/VersionContextMenu";
import EditVersionModal from "../EditVersionModal/EditVersionModal";
import useIsMobile from "../../hooks/useIsMobile";
import { OrbitProgress } from "react-loading-indicators";
import { currentUploadingVideosSelector } from "../../store/selectors";
import ShareModal from "../ShareModal/ShareModal";

const DummyPostersArray = [
  DummyPoster1,
  DummyPoster2,
  DummyPoster3,
  DummyPoster4,
  DummyPoster5,
];

const VersionPreview = ({
  isShared,
  versionInfo: {
    id: versionId,
    commentCount = 0,
    title,
    version,
    // videoStatus,
    // status,
    description,
    screenshot = null,
    screenshots = [],
    versionsCount = 0,
    createdDate,
  },
  item,
  currentlyUploadingVideo,
  uploadStatus,
  vidStatus,
  reuploadedVersionId,
  setReuploadedVersionId,
  fetchCurrentProjectById = () => {},
  onClick,
  reuploadVersion,
  project,
  onDelete,
  onArchive,
  onRestore,
  isArchive,
}) => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const [isDeleting, setIsDeleting] = useState(false);
  const [isNotUploaded, setIsNotUploaded] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [timeAgo, setTimeAgo] = useState("");
  const { openMenuId, openMenu, closeMenu } = useMenu();
  const { t } = useTranslation();
  const showMenu = openMenuId === versionId;

  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const dotsRef = useRef(null);
  const menuRef = useRef(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const currentUploadingVideosInfo = useSelector(
    currentUploadingVideosSelector
  );
  const timeToProcess = 10;
  const DummyPoster = DummyPostersArray[0];

  useEffect(() => {
    const videoStatus = currentlyUploadingVideo
      ? currentlyUploadingVideo.data.videoStatus
      : item.videoStatus;
    const status = currentlyUploadingVideo
      ? currentlyUploadingVideo.data.status
      : item.status;
    const isEmpty = videoStatus === "empty" || !videoStatus;
    const isPending = videoStatus === "pending";
    const isFinal = status === "FINAL";
    const uploadedTime = momentWithLocales(createdDate).locale("ru");
    const timeFromNow = moment().locale("ru").diff(uploadedTime, "seconds");
    const isCurrentlyUploading = !!currentlyUploadingVideo && !isFinal;
    setTimeAgo(uploadedTime.fromNow());

    // console.log(
    //   versionId,
    //   isCurrentlyUploading,
    //   isEmpty,
    //   isFinal,
    //   isPending,
    //   currentlyUploadingVideo
    // );

    if (isCurrentlyUploading) {
      setIsNotUploaded(false);
      setIsProcessing(false);
      setIsUploading(true);
    } else if (isEmpty && !isFinal) {
      setIsNotUploaded(true);
      setIsProcessing(false);
      setIsUploading(false);
    } else if (
      isPending ||
      (isEmpty && isFinal) ||
      (isEmpty && !isFinal && timeFromNow < timeToProcess)
    ) {
      setIsNotUploaded(false);
      setIsProcessing(true);
      setIsUploading(false);
    } else {
      setIsNotUploaded(false);
      setIsProcessing(false);
      setIsUploading(false);
    }
  }, [item, currentlyUploadingVideo]);

  useEffect(() => {
    if (reuploadedVersionId === versionId) {
      setIsNotUploaded(false);
      setIsProcessing(true);
      setReuploadedVersionId(null);
    }
  }, [reuploadedVersionId]);

  useEffect(() => {
    if (!showMenu) return;
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        dotsRef.current &&
        !dotsRef.current.contains(event.target)
      ) {
        closeMenu();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  const handleMenuClick = (e) => {
    if (isShared) return;
    e.stopPropagation();
    if (showMenu) {
      closeMenu();
    } else {
      if (dotsRef.current) {
        const rect = dotsRef.current.getBoundingClientRect();
        setMenuPosition({
          top: rect.bottom + window.scrollY + 4, // 4px margin
          left: rect.right + window.scrollX - 224, // align right edge
        });
      }
      openMenu(versionId);
    }
  };

  const formatDate = (dateString) => {
    const res = momentTz(dateString).tz("etc/gmt-3").format("DD.MM.YY");
    return res;
  };

  const handleDelete = async (e, versionId) => {
    onDelete(versionId, e);
    closeMenu();
  };

  const handleArchive = async (e, versionId) => {
    onArchive(versionId, e);
    closeMenu();
  };

  const handleRestore = async (e, versionId) => {
    onRestore(versionId, e);
    closeMenu();
  };

  const handleRename = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setIsEditModalOpen(true);
    closeMenu();
  };

  const styles = {
    container: {
      width: isMobile ? "100%" : 330,
      height: 220,
      borderRadius: "16px",
      backgroundColor: "#1F242E",
      overflow: "visible",
      position: "relative",
      cursor: "default",
      display: "flex",
      flexDirection: "column",
    },
    imageContainer: {
      width: "100%",
      height: 122,
      position: "relative",
      backgroundColor:
        !isNotUploaded && !isProcessing && !isUploading ? "#181c24" : "#333b4b",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: isUploading || isProcessing ? "default" : "pointer",
      borderTopLeftRadius: "16px",
      borderTopRightRadius: "16px",
      borderBottomLeftRadius: "16px",
      borderBottomRightRadius: "16px",
      overflow: "hidden",
    },
    screenshotContainer: {
      width: "100%",
      // marginLeft: "0.5%",
      height: "100%",
      position: "relative",
      backgroundColor: "#181c24",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      borderRadius: 16,
      overflow: "hidden",
    },
    posterImage: {
      width: isHovered ? "105%" : "100%",
      height: isHovered ? "105%" : "100%",
      objectFit: "cover",
      display: "block",
      borderRadius: "16px 16px 0 0",
      transition: "width 0.2s ease, height 0.2s ease",
    },
    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      display: "block",
      borderRadius: "16px 16px 0 0",
    },
    content: {
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "flex-end",
      gap: 8,
      width: "100%",
      // marginLeft: "0.5%",
      height: "100%",
      position: "absolute",
      bottom: isMobile ? -1 : 0,
      zIndex: 2,
    },
    bottomContent: {
      width: "100%",
      flex: 1,
      padding: 16,
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      justifyContent: "space-between",
      boxSizing: "border-box",
      position: "absolute",
      height: isHovered ? 102 : 98,
      borderRadius: 16,
      paddingTop: 12,
      transition: "height 0.2s ease",
      backgroundColor: "#00051489",
      // boxShadow: isHovered
      //   ? "-1px -24px 23px -13px rgba(74, 158, 223, 0.36)"
      //   : "none",
    },
    title: {
      color: "#c1c4cb",
      textAlign: "left",
      fontSize: "14px",
      fontWeight: 600,
      fontFamily: "NT Somic, sans-serif",
      margin: 0,
      cursor: isUploading || isProcessing ? "default" : "pointer",
      textDecoration: "none",
      // transition: "text-decoration 0.2s",
      height: "40px",
      maxWidth: "100%",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      lineHeight: "20px",
      "&:hover": {
        textDecoration: "underline",
      },
      fontSize: isHovered ? 16 : 14,
      transition: "font-size 0.2s ease",
    },
    bottomRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      height: "24px",
      gap: "10px",
    },
    commentsBadge: {
      backgroundColor: "transparent",
      borderRadius: "80px",
      color: "#717b8e",
      fontSize: "12px",
      fontWeight: 500,
      fontFamily: "NT Somic, sans-serif",
      display: "flex",
      alignItems: "center",
    },
    metaInfo: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      height: "24px",
      width: "54%",
      justifyContent: "flex-end",
    },
    timeInfo: {
      display: "flex",
      alignItems: "center",
      gap: "4px",
      maxWidth: "85%",
      height: "24px",
    },
    timeText: {
      color: "#717b8e",
      fontSize: "12px",
      fontWeight: 400,
      marginBottom: 2,
      overflow: "hidden",
      whiteSpace: "nowrap",
      fontFamily: "NT Somic, sans-serif",
      textOverflow: "ellipsis",
    },
    icon: {
      width: "16px",
      height: "16px",
    },
    menuIcon: {
      width: "16px",
      height: "16px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
    },
    loader: {
      width: "40px",
      height: "40px",
      border: "4px solid #333b4b",
      borderTop: "4px solid #4CAF50",
      borderRadius: "50%",
      animation: "spin 1s linear infinite",
    },
    repeatUpload: {
      width: "100%",
      height: "100%",
      display: "flex",
      color: "white",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "14px",
      fontWeight: 400,
      fontFamily: "NT Somic, sans-serif",
    },
    videoProcessing: {
      width: "100%",
      height: "100%",
      display: "flex",
      color: "white",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      fontSize: "14px",
      fontWeight: 400,
      fontFamily: "NT Somic, sans-serif",
    },
    videoProcessingText: {
      color: "white",
      fontSize: "14px",
      fontWeight: 400,
      fontFamily: "NT Somic, sans-serif",
      marginTop: 10,
    },
    commentsText: {
      color: "#717b8e",
      fontSize: "12px",
      fontWeight: 400,
      fontFamily: "NT Somic, sans-serif",
      paddingBottom: "3px",
      overflowX: "hidden",
      whiteSpace: "nowrap",
    },
  };

  const getNumberedLocalizedString = (amount, key) => {
    let keyLocalized = `${key}_1`;
    if (amount % 10 === 1) {
      keyLocalized = `${key}_1`;
    } else if (amount % 10 > 1 && amount % 10 < 4) {
      keyLocalized = `${key}_2`;
    } else if (amount % 10 === 0 || amount % 10 > 4) {
      keyLocalized = `${key}_3`;
    }

    return `${amount} ${t(keyLocalized)}`;
  };

  const handleClickVersion = (e) => {
    if (showShareModal) return;
    if (isArchive) {
      handleMenuClick(e);
      return;
    }
    if (isEditModalOpen) return;
    if (!isUploading && !isProcessing && !isNotUploaded) {
      onClick();
      return;
    }
    if (!isUploading && !isProcessing && isNotUploaded) {
      reuploadVersion(versionId);
    }
  };

  const screenshotIndex =
    (screenshots && screenshots.length && Math.floor(screenshots.length / 2)) ||
    -1;
  const screenshotUrl = screenshotIndex > -1 && screenshots[screenshotIndex];

  if (isNotUploaded) {
    return (
      <div style={styles.container}>
        <div style={styles.screenshotContainer}>
          <img
            src={screenshotUrl || screenshot || DummyPoster}
            alt="View"
            style={styles.posterImage}
          />
        </div>
        <div style={styles.content}>
          <div
            style={{
              ...styles.imageContainer,
              cursor: "default",
              height: "100%",
              paddingBottom: "27%",
            }}
            onClick={() => {
              reuploadVersion(versionId);
            }}
          >
            <div style={{ ...styles.repeatUpload, cursor: "pointer" }}>
              <span>Повторить загрузку</span>
            </div>
          </div>

          <div style={styles.bottomContent}>
            <h3
              style={{
                ...styles.title,
                cursor: "default",
              }}
              onClick={() => {}}
            >
              {version}
            </h3>
            <div
              style={{
                ...styles.bottomRow,
                justifyContent: isArchive ? "flex-end" : "space-between",
              }}
            >
              <div style={styles.commentsBadge}>
                <img src={commentsIcon} style={{ width: 24, height: 24 }} />
                <span style={styles.commentsText}>
                  {getNumberedLocalizedString(
                    commentCount,
                    "mainScreen.projects.comments"
                  )}
                </span>
              </div>
              <div style={styles.metaInfo}>
                <div style={styles.timeInfo}>
                  <img src={eyeIcon} alt="View" style={styles.icon} />
                  <span style={styles.timeText}>{timeAgo}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{ ...styles.container, cursor: "pointer" }}
      onMouseEnter={(e) => !isUploading && !isProcessing && setIsHovered(true)}
      onMouseLeave={(e) => !isUploading && !isProcessing && setIsHovered(false)}
    >
      <div style={styles.screenshotContainer}>
        <img
          src={screenshotUrl || screenshot || DummyPoster}
          alt="View"
          style={styles.posterImage}
        />
      </div>

      <div style={styles.content} onClick={handleClickVersion}>
        {(isProcessing || isUploading) && (
          <div
            style={{
              ...styles.imageContainer,
              cursor: isUploading || isProcessing ? "default" : "pointer",
              opacity: 1,
              cursor: "default",
              height: "100%",
              paddingBottom: "27%",
            }}
            onClick={handleClickVersion}
          >
            {isProcessing ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div style={styles.videoProcessing}>
                  <OrbitProgress
                    style={{ fontSize: 8 }}
                    color="rgb(166, 134, 237)"
                  />
                  <span style={styles.videoProcessingText}>
                    Видео обрабатывается
                  </span>
                </div>
              </div>
            ) : isUploading ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div style={styles.videoProcessing}>
                  <OrbitProgress style={{ fontSize: 8 }} color="#427FFF" />
                  <span style={styles.videoProcessingText}>
                    Видео загружается
                  </span>
                </div>
              </div>
            ) : null}
          </div>
        )}
        <div
          style={{
            position: "absolute",
            backgroundColor: "#1F242E",
            padding: "4px 8px",
            paddingTop: 1,
            top: 15,
            left: 15,
            borderRadius: 80,
            zIndex: 9,
          }}
        >
          <span
            style={{ color: isHovered ? "#C1C7D4" : "#717B8E", fontSize: 12 }}
          >
            {formatDate(createdDate)}
          </span>
        </div>
        <div onClick={handleClickVersion} style={styles.bottomContent}>
          <h3
            style={{
              ...styles.title,
              cursor: isUploading || isProcessing ? "default" : "pointer",
              color: isHovered ? "#F1F7FF" : "#C1C7D4",
            }}
            onClick={!isUploading && !isProcessing ? onClick : undefined}
          >
            {version}
          </h3>
          <div
            style={{
              ...styles.bottomRow,
              justifyContent: isArchive ? "flex-end" : "space-between",
            }}
          >
            <div
              style={{
                ...styles.commentsBadge,
                display: isArchive ? "none" : "flex",
              }}
            >
              <img src={commentsIcon} style={{ width: 24, height: 24 }} />
              <span style={styles.commentsText}>
                {getNumberedLocalizedString(
                  commentCount,
                  "mainScreen.projects.comments"
                )}
                {/* 0 комментариев */}
              </span>
            </div>
            <div style={styles.metaInfo}>
              <div
                style={{
                  ...styles.timeInfo,
                  display: isArchive ? "none" : "flex",
                }}
              >
                <img src={eyeIcon} alt="View" style={styles.icon} />
                <span style={styles.timeText}>{timeAgo}</span>
                {/* <span style={styles.timeText}> Несколько секунд назад</span> */}
              </div>
              {!isProcessing && !isUploading && (
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    padding: 10,
                    paddingRight: 0,
                  }}
                >
                  <img
                    ref={dotsRef}
                    src={dotsIcon}
                    alt="Menu"
                    style={styles.menuIcon}
                    onMouseOver={(e) => (e.target.style.opacity = "0.8")}
                    onMouseOut={(e) => (e.target.style.opacity = "1")}
                    onClick={handleMenuClick}
                  />
                  {showMenu && (
                    <VersionContextMenu
                      ref={menuRef}
                      versionId={versionId}
                      onRename={handleRename}
                      onOpenShare={(e) => setShowShareModal(true)}
                      onRestore={(e) => handleRestore(e, versionId)}
                      onArchive={(e) => handleArchive(e, versionId)}
                      onDelete={(e) => handleDelete(e, versionId)}
                      isArchive={isArchive}
                      onClose={closeMenu}
                      usePortal={true}
                      style={{
                        position: "absolute",
                        top: menuPosition.top,
                        left: menuPosition.left,
                        zIndex: 2000,
                      }}
                    />
                  )}
                  {isEditModalOpen && (
                    <EditVersionModal
                      fetchCurrentProjectById={fetchCurrentProjectById}
                      version={{ version, versionId }}
                      status={vidStatus}
                      currentProject={project}
                      onClose={() => setIsEditModalOpen(false)}
                      onRenamed={() => setIsEditModalOpen(false)}
                    />
                  )}
                  {showShareModal && (
                    <ShareModal
                      isOpen={showShareModal}
                      versionId={versionId}
                      project={{ id: project.id }}
                      onClose={() => setShowShareModal(false)}
                      handleOpenBacklog={() => {}}
                      handleChangeCover={() => {}}
                      handleRenameProject={() => {}}
                      handleDeleteProject={() => {}}
                      handleArchiveProject={() => {}}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VersionPreview;
